/* eslint-disable react-hooks/rules-of-hooks */
import { AmmoPhysics, Clock } from "@enable3d/ammo-physics";
import { useFrame, useThree } from "@react-three/fiber";
import { PhysicsLoader } from "enable3d";

import { useCallback, useEffect, useRef, useState } from "react";
import { suspend } from "suspend-react";
import { DefaultLoadingManager } from "three";
import { useStore } from "../store/Store";

export const usePhysics = (
  enable: boolean = false
): AmmoPhysics | undefined => {
  const [loaded, setPhysicsLoaded] = useState(false);
  const loadingManager = DefaultLoadingManager;
  const setPhysics = useStore((store) => store.setPhysics);
  const physics = useStore((store) => store.physics);
  const { scene } = useThree();
  const animate = useCallback(() => {
    // update physics
    physics?.update(clock.current.getDelta() * 1000);
    // update the physics debugger
    physics?.updateDebugger();

    requestAnimationFrame(animate);
  }, [physics]);

  useFrame(() => {
    if (physics) {
      animate();
    }
  });

  const clock = useRef(new Clock());

  // This is done, because it ensures that the itemStart function is only called once
  suspend(async () => {
    loadingManager.itemStart(process.env.REACT_APP_AMMO_PATH || "enable3d");
  }, [process.env.REACT_APP_AMMO_PATH || "enable3d"]);

  useEffect(() => {
    if (!scene || loaded) return;
    // load the ammo.js file from the /lib folder and start the project
    if (enable) {
      PhysicsLoader(process.env.REACT_APP_AMMO_PATH || "", () => {
        console.info("physics loaded");
        const _physics = new AmmoPhysics(scene);
        setPhysicsLoaded(true);
        setPhysics(_physics);
        loadingManager.itemEnd(process.env.REACT_APP_AMMO_PATH || "enable3d");
        _physics.debug?.enable();
      });
    }
  }, [scene, loaded, loadingManager, enable, setPhysics]);

  return physics;
};
